// Round 106, GAP 2 — shared classification of why an admin fetch failed.
//
// Deliberately imports NOTHING from apiProxy.ts: apiProxy imports THIS file
// (for the event name), and apiProxy.ts contains `import.meta.env`, a hard
// syntax error under this repo's ts-jest config — keeping this module free of
// it is what lets the classification be unit-tested. Hence duck-typing on
// `.code` rather than `instanceof ApiFetchError`.

/** apiFetch dispatches this on window when ANY admin API call is refused with
 *  code MFA_REQUIRED, so AdminLayout can show the re-verify screen no matter
 *  how (or whether) the calling page handles its own error. */
export const ADMIN_MFA_REQUIRED_EVENT = 'emi:admin-mfa-required';

/** The backend (src/middleware/adminAuth.ts requireRole) refused a session
 *  that carries no TOTP second-factor claim while enforcement is on. */
export function isMfaRequiredError(err: unknown): boolean {
  return (err as { code?: unknown } | null)?.code === 'MFA_REQUIRED';
}

/** Firestore's own refusal. With the Round 106 rules this is what a
 *  first-factor session gets on the dashboard's direct reads. */
export function isPermissionDenied(err: unknown): boolean {
  return (err as { code?: unknown } | null)?.code === 'permission-denied';
}

export function describeError(err: unknown): string {
  const message = (err as { message?: unknown } | null)?.message;
  return typeof message === 'string' && message ? message : 'Unknown error';
}
